/**
 * Store Infinite Scroll JavaScript
 *
 * Adds a body class when Ajax Load More is live on the store archive so the
 * numbered block pagination can be hidden. See store.css for the rule.
 */

( function () {
	'use strict';

	/**
	 * Flag the document when Ajax Load More is present on the page.
	 *
	 * Ajax Load More prints `.ajax-load-more-wrap` only when it actually renders
	 * its shortcode, so the presence of that wrapper is the signal that infinite
	 * scroll is set up for this archive.
	 *
	 * Making the check from JavaScript rather than in CSS is deliberate. Ajax
	 * Load More needs scripting to load anything, so the pagination should only
	 * disappear under the same condition. Visitors with JavaScript disabled, and
	 * crawlers that do not execute it, keep the server rendered pagination links
	 * and can still reach every page of the catalog.
	 */
	function flagInfiniteScroll() {
		if ( ! document.querySelector( '.ajax-load-more-wrap' ) ) {
			return;
		}

		document.body.classList.add( 'has-alm-infinite-scroll' );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', flagInfiniteScroll );
	} else {
		flagInfiniteScroll();
	}
} )();
